import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { Signup } from '@models/signup/signup';
import { HttpService } from '@services/http.service';
import { InfoLogin } from '@models/login/info/info-login';
import { EndpointParams } from '@models/utils/endpoint-params';

@Injectable({
    providedIn: 'root'
})
export class SignupService extends HttpService {
    private readonly defaultEndpointParams: EndpointParams = { app: 'member', version: 1 };
    private dataStore: { infoLogin: InfoLogin } = { infoLogin: new InfoLogin()};

    getInfoLogin(): InfoLogin {
        return this.dataStore.infoLogin;
    }

    signup(memberSignup: Signup, publicToken: string, token: string): Observable<any> {
        return this.post(`polaris/signup?centerToken=${publicToken}&recaptcha=${token}`, this.defaultEndpointParams, memberSignup, this.noShowErrorNotification)
            .pipe(tap(data => {
                this.dataStore.infoLogin = new InfoLogin().build(data);
            }));
    }
}
